var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4.39111C13.5 6.32411 11.933 7.89111 10 7.89111C8.067 7.89111 6.5 6.32411 6.5 4.39111C6.5 2.45812 8.067 0.891113 10 0.891113C11.933 0.891113 13.5 2.45812 13.5 4.39111Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78164 5.39111C4.78164 6.27477 4.0653 6.99111 3.18164 6.99111C2.29799 6.99111 1.58164 6.27477 1.58164 5.39111C1.58164 4.50746 2.29799 3.79111 3.18164 3.79111C4.0653 3.79111 4.78164 4.50746 4.78164 5.39111Z",
    stroke: "black",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9988 16.3913C17.0093 15.4946 16.8402 14.6047 16.5015 13.7732C16.1627 12.9418 15.661 12.1852 15.0253 11.5474C14.3897 10.9096 13.6328 10.4033 12.7984 10.0577C11.9641 9.71213 11.0689 9.53418 10.1647 9.53418C9.26049 9.53418 8.36529 9.71213 7.53093 10.0577C6.69658 10.4033 5.93965 10.9096 5.304 11.5474C4.66836 12.1852 4.16662 12.9418 3.82787 13.7732C3.48911 14.6047 3.32007 15.4946 3.33054 16.3913",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95231 8.89446C5.57867 8.66729 5.16441 8.51903 4.73353 8.45827C4.30265 8.39751 3.86371 8.42547 3.44213 8.54051C3.02056 8.65556 2.62473 8.85541 2.27758 9.12849C1.93044 9.40157 1.63887 9.74244 1.41977 10.1314C1.20067 10.5203 1.05839 10.9496 1.00118 11.3943",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.3911L12 14.3911",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerblack);
export default __webpack_public_path__ + "static/media/customerblack.941f9bbcf94e404b5758ede4e3084834.svg";
export { ForwardRef as ReactComponent };